module.exports = __webpack_public_path__ + "img/lair-throne-base.ead8d7ab.jpeg";